export function getErrorMessageForAlert(errorResponse) {
  if (typeof errorResponse === 'string' && errorResponse.trim().length > 0) {
    return errorResponse
  }

  if (errorResponse && typeof errorResponse === 'object') {
    for (const key of ['reason', 'error', 'message']) {
      if (
        key in errorResponse &&
        typeof errorResponse[key] === 'string' &&
        errorResponse[key].trim().length > 0
      ) {
        return errorResponse[key]
      }
    }
  }

  return ''
}

export function getErrorMessageFromHttpError(error) {
  return getErrorMessageForAlert(error?.response?.data)
}
